import { AlarmsSagasListener } from './Alarms/sagas';
import { DevicesSagasListener } from './Devices/sagas';
import { DisablerSagasListener } from './Disabler/sagas';
import { DriversSagasListener } from './Drivers/sagas';
import { EventsInfoTabSagasListener } from './EventsInfoTab/sagas';
import { FleetSagasListener } from './Fleet/sagas';
import { FuelCardSagasListener } from './FuelCard/sagas';
import { GeocodeSagasListener } from './Geocode/sagas';
import { GeofenceFormSagasListener } from './GeofenceForm/sagas';
import { GeofenceSagasListener } from './Geofences/sagas';
import { InvitesSagasListener } from './Invites/sagas';
import { LoginSagasListener } from './Login/sagas';
import { PasswordSagasListener } from './Password/sagas';
import { ReportsSagasListener } from './Performance/Reports/sagas';
import { UserSagasListener } from './Users/sagas';
import { VehiclePopupSagasListener } from './VehiclePopup/sagas';
import { VehiclesTabSagasListener } from './VehiclesTab/sagas';
import type { SagaMiddleware } from 'redux-saga';

import { ChecklistSagasListener } from '@cobliteam/checklists';
import { CostsSagasListener } from '@cobliteam/costs';
import { DeviceConfigurationSagasListener } from '@cobliteam/device-configuration';
import {
  PastMaintenancesSagasListener,
  RegisterMaintenanceSagasListener,
  UpcomingMaintenancesSagasListener,
} from '@cobliteam/maintenance';
import { RoutesSagasListener } from '@cobliteam/routing/src/store/Routes/sagas';
import { NewRoutingSagasListener } from '@cobliteam/routing/src/store/Routing/sagas';
import {
  RouteHistorySagasListener,
  TrackingSagasListener,
} from '@cobliteam/tracking';
import {
  UserAlertSettingSagasListener,
  UserAlertsSagasListener,
} from '@cobliteam/user-alerts';

import {
  MonitoringVehiclesTabSagasListener,
  VehicleSagasListener,
} from '@cobliteam/store';

const arrayOfSagas = [
  DriversSagasListener,
  DisablerSagasListener,
  EventsInfoTabSagasListener,
  FuelCardSagasListener,
  GeofenceSagasListener,
  VehicleSagasListener,
  VehiclesTabSagasListener,
  FleetSagasListener,
  GeocodeSagasListener,
  CostsSagasListener,
  ReportsSagasListener,
  DevicesSagasListener,
  GeofenceFormSagasListener,
  UserSagasListener,
  InvitesSagasListener,
  AlarmsSagasListener,
  PastMaintenancesSagasListener,
  UpcomingMaintenancesSagasListener,
  RegisterMaintenanceSagasListener,
  PasswordSagasListener,
  VehiclePopupSagasListener,
  ChecklistSagasListener,
  TrackingSagasListener,
  RouteHistorySagasListener,
  UserAlertsSagasListener,
  UserAlertSettingSagasListener,
  NewRoutingSagasListener,
  RoutesSagasListener,
  LoginSagasListener,
  MonitoringVehiclesTabSagasListener,
  DeviceConfigurationSagasListener,
];

const SagaMiddlewares = (sagaMiddleware: SagaMiddleware) => {
  arrayOfSagas.forEach(sagaMiddleware.run);
};

export default SagaMiddlewares;
